/**
 * Summary Stats Component
 *
 * Displays summary statistics (invested, returns, current value).
 */

import { cn } from "@/lib/utils";
import { formatCurrency, formatPercentage } from "../utils";

interface SummaryStatsProps {
  investedAmount: number;
  currentValue: number;
}

/**
 * Summary statistics row
 */
export function SummaryStats({ investedAmount, currentValue }: SummaryStatsProps) {
  const returns = currentValue - investedAmount;
  const returnsPercent = (returns / investedAmount) * 100;
  const isPositive = returns >= 0;

  return (
    <div className="flex justify-between items-center text-sm mb-4">
      <div>
        <span className="text-muted-foreground text-xs">Invested</span>
        <p className="font-semibold">{formatCurrency(investedAmount)}</p>
      </div>
      <div className="text-center">
        <span className="text-muted-foreground text-xs">Returns</span>
        <p
          className={cn(
            "font-semibold",
            isPositive ? "text-emerald-600" : "text-rose-600"
          )}
        >
          {isPositive ? "+" : ""}
          {formatCurrency(Math.abs(returns))} ({formatPercentage(returnsPercent)})
        </p>
      </div>
      <div className="text-right">
        <span className="text-muted-foreground text-xs">Current</span>
        <p className="font-semibold">{formatCurrency(currentValue)}</p>
      </div>
    </div>
  );
}
